/**
 * 时间格式方法
 *
 * @param {any} timeStamp  时间戳，秒级/毫秒级
 * @param {any} type 格式化时间类型，默认  Y-M-D H:I:S
 * @returns {string} formatTime 格式化后的时间 例如： 2017-05-05 12:09:22
 */
function formatDate(timeStamp, type = "Y-M-D H:I:S", auto = false, short = false) {
  let time = (timeStamp + "").length === 10 ? new Date(parseInt(timeStamp) * 1000) : new Date(parseInt(timeStamp));
  let _year = time.getFullYear();
  _year = short ? +(_year + "").substring(2) : _year;
  let _month = time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1;
  let _date = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
  let _hours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
  let _minutes = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
  let _secconds = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
  let formatTime = "";
  let distinctTime = new Date().getTime() - time.getTime();

  if (auto) {
    if (distinctTime <= 1 * 60 * 1000) {
      // console.log('一分钟以内，以秒数计算');
      let _s = Math.floor((distinctTime / 1000) % 60);
      formatTime = _s + "秒前";
    } else if (distinctTime <= 1 * 3600 * 1000) {
      // console.log('一小时以内,以分钟计算');
      let _m = Math.floor((distinctTime / (60 * 1000)) % 60);
      formatTime = _m + "分钟前";
    } else if (distinctTime <= 24 * 3600 * 1000) {
      // console.log('一天以内，以小时计算');
      let _h = Math.floor((distinctTime / (60 * 60 * 1000)) % 24);
      formatTime = _h + "小时前";
    } else if (distinctTime <= 30 * 24 * 3600 * 1000) {
      let _d = Math.floor((distinctTime / (24 * 60 * 60 * 1000)) % 30);
      formatTime = _d + "天前";
      // console.log('30天以内,以天数计算');
    } else {
      // 30天以外只显示年月日
      formatTime = _year + "-" + _month + "-" + _date;
    }
  } else {
    switch (type) {
      case "Y-M-D H:I:S":
        formatTime = _year + "-" + _month + "-" + _date + " " + _hours + ":" + _minutes + ":" + _secconds;
        break;
      case "Y.M.D":
        formatTime = _year + "." + _month + "." + _date;
        break;
      case "M/D":
        formatTime = _month + "/" + _date;
        break;
      case "Y-M-D H:I:S zh":
        formatTime = _year + "年" + _month + "月" + _date + "日  " + _hours + ":" + _minutes + ":" + _secconds;
        break;
      case "Y-M-D":
        formatTime = _year + "-" + _month + "-" + _date;
        break;
      case "Y/M/D":
        formatTime = _year + "/" + _month + "/" + _date;
        break;
      case "Y-M-D zh":
        formatTime = _year + "年" + _month + "月" + _date + "日";
        break;
      case "Y/M/D H:I":
        formatTime = _year + "/" + _month + "/" + _date + " " + _hours + ":" + _minutes;
        break;
      case "H:I:S":
        formatTime = _hours + ":" + _minutes + ":" + _secconds;
        break;
      case "H:I":
        formatTime = _hours + ":" + _minutes;
        break;
      default:
        formatTime = _year + "-" + _month + "-" + _date + " " + _hours + ":" + _minutes + ":" + _secconds;
        break;
    }
  }
  // 返回格式化的日期字符串
  return formatTime;
}

/**
 * 防抖
 * @param {function} fn
 * @param {this} context
 * @param {number} delay
 * @param {number} watiTime
 * @returns
 */
function debounce(fn, context, delay = 500, watiTime = 200) {
  let timer = null,
    startTime;
  return function loop() {
    let args = [...arguments],
      curTime = +new Date();
    if (!startTime) {
      startTime = curTime;
    }
    timer && clearTimeout(timer);
    if (curTime - startTime > watiTime) {
      fn.apply(context, args);
      startTime = curTime;
    } else {
      timer = setTimeout(() => {
        loop.apply(context, args);
      }, delay);
    }
  };
}

/**
 * 改变blob图片的质量，为考虑兼容性
 * @param blob 图片对象
 * @param callback 转换成功回调，接收一个新的blob对象作为参数
 * @param format 目标格式，mime格式
 * @param quality 介于0-1之间的数字，用于控制输出图片质量，仅当格式为jpg和webp时才支持质量，png时quality参数无效
 */
function changeBlobImageQuality(blob, callback, format, quality) {
  format = format || "image/jpeg";
  quality = quality || 0.9; // 经测试0.9最合适
  var fr = new FileReader();
  fr.onload = function(e) {
    var dataURL = e.target.result;
    var img = new Image();
    img.onload = function() {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      var newDataURL = canvas.toDataURL(format, quality);
      if (callback) callback(dataURLtoBlob(newDataURL));
      canvas = null;
    };
    img.src = dataURL;
  };
  fr.readAsDataURL(blob); // blob 转 dataURL
  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      len = bstr.length,
      u8arr = new Uint8Array(len);
    while (len--) u8arr[len] = bstr.charCodeAt(len);
    return new Blob([u8arr], { type: mime });
  }
}

export { formatDate, debounce, changeBlobImageQuality };
